import autobind from 'core-decorators/lib/autobind';
import classnames from 'classnames';

import { WixConnect } from 'widget/player-widget/utils/wix-connect';

import styles from './control-button.styl';

import { pickContextTypes } from '../context-types';


@WixConnect(styles)
export default class ControlButton extends React.Component {

  static contextTypes = pickContextTypes('fullScreen');

  static propTypes = {
    children: React.PropTypes.any,
    onMenuToggle: React.PropTypes.func,
    tooltip: React.PropTypes.shape({
      content: React.PropTypes.any,
      position: React.PropTypes.oneOf(['center', 'left', 'right']),
    }),
    menu: React.PropTypes.shape({
      content: React.PropTypes.any,
      position: React.PropTypes.oneOf(['center', 'left', 'right']),
    }),
  };

  state = {
    menuOpen: false,
  };

  componentDidMount() {
    window.addEventListener('blur', this.handleClickOutside, false);
    document.addEventListener('click', this.handleClickOutside, false);
  }

  componentWillUnmount() {
    window.removeEventListener('blur', this.handleClickOutside, false);
    document.removeEventListener('click', this.handleClickOutside, false);
  }

  @autobind
  handleClickOutside(event) {
    const { target } = event;
    if (target !== window && this.wrapper && this.wrapper.contains(target)) {
      return;
    }

    this.toggleMenu(false);
  }

  @autobind
  toggleMenu(menuOpen) {
    const { menu, onMenuToggle } = this.props;

    if (!menu) {
      return;
    }

    if (!_.isBoolean(menuOpen)) {
      menuOpen = !this.state.menuOpen;
    }

    this.setState({
      menuOpen,
    });

    if (onMenuToggle) {
      onMenuToggle(menuOpen);
    }
  }

  renderPopout(type, { className, content, position = 'center' }) {
    const outerStyleNames = classnames('popout', `popout--${type}`, `popout--${position}`);
    const innerStyleNames = classnames('popout--inner', type);

    return (
      <span styleName={outerStyleNames}>
        <span styleName={innerStyleNames}
              className={className}>
          {content}
        </span>
      </span>
    );
  }

  render() {
    const { tooltip, menu, children } = this.props;
    const otherProps = _.omit(this.props, ['tooltip', 'menu', 'children']);
    const { menuOpen } = this.state;
    const { fullScreen } = this.context;

    const props = _({})
      .assign(otherProps, {
        ref: node => (this.wrapper = node),
        styleName: classnames('control-button', {
          'menu-open': menuOpen,
          'full-screen': fullScreen,
        }),
        onMouseDown: this.toggleMenu,
      })
      .omit('intl', 'appSettings', 'styles')
      .value();

    return (
      <span {...props}>
        {tooltip && this.renderPopout('tooltip', tooltip)}
        {menu && this.renderPopout('tooltip', menu)}
        {children}
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/widget/player-widget/components/player/control-button/control-button.js